import { useI18n } from '@/i18n';
import { useTheme } from '@/app/theme';
import { cn } from '@/shared/cn';
import type { LocaleCode, ThemePreference } from '@/shared/storage';

const themes: ThemePreference[] = ['system', 'light', 'dark'];

export function TopBar() {
  const { t, locale, setLocale } = useI18n();
  const { theme, setTheme } = useTheme();

  return (
    <header className="mb-6 flex flex-wrap items-center justify-between gap-3">
      <div>
        <p className="font-display text-2xl font-extrabold tracking-tight text-vz-ink">{t('brand')}</p>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <label className="sr-only" htmlFor="locale">
          {t('language')}
        </label>
        <select
          id="locale"
          className="rounded-xl border border-vz-line bg-vz-surface px-3 py-2 text-sm font-semibold text-vz-ink"
          value={locale}
          onChange={(e) => setLocale(e.target.value as LocaleCode)}
        >
          <option value="pt">PT</option>
          <option value="en">EN</option>
        </select>
        <div className="flex rounded-xl border border-vz-line bg-vz-surface p-1">
          {themes.map((value) => (
            <button
              key={value}
              type="button"
              className={cn(
                'rounded-lg px-2.5 py-1.5 text-xs font-bold transition',
                theme === value
                  ? 'bg-vz-accent text-vz-accent-ink'
                  : 'text-vz-muted hover:text-vz-ink',
              )}
              onClick={() => setTheme(value)}
            >
              {value === 'system'
                ? t('themeSystem')
                : value === 'light'
                  ? t('themeLight')
                  : t('themeDark')}
            </button>
          ))}
        </div>
      </div>
    </header>
  );
}
